// modified RFC 2822
const EMAIL_REGEX =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)\S{8,}$/;
const FALLBACK_PASSWORD_REGEX = /^.+$/;
const NUMBER_ONLY_REGEX = /[^0-9,.]/g;

export {
  EMAIL_REGEX,
  PASSWORD_REGEX,
  FALLBACK_PASSWORD_REGEX,
  NUMBER_ONLY_REGEX,
};
